import React, { useEffect, useState } from "react";
import RequestCard from "../../RequestCard/RequestCard";
import { active } from "../../../../../ui_libs/constants";
import { invokeApi } from "../../../../../bl_libs/invokeApi";
import { CircularProgress } from "@material-ui/core";
import { withRouter } from "react-router-dom";
function Active(props) {
  const [requests, SetRequests] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  //fetch Active request from Api
  const fetchActiveRequests = () => {
    let requestObj = {
      path: "/api/customer/get_customer_request",
      method: "POST",
      headers: {
        "x-sh-auth": localStorage.getItem("token"),
      },
    };
    let postData = {
      request_status: active,
    };
    requestObj["postData"] = postData;
    invokeApi(requestObj).then((res) => {
      console.log(res);
      if (res.code === 200) {
        props.setCounts({
          ...props.counts,
          activeCount: res.request_count.active_request_count,
          doneCount: res.request_count.done_request_count,
          cancelCount: res.request_count.cancle_request_count,
        });
        SetRequests(res.data);
        setIsLoading(false);
      }
    });
  };
  useEffect(() => {
    fetchActiveRequests();
  }, []);

  if (isLoading) {
    return (
      <>
        <div className="Circular-Progress">
          <CircularProgress />
        </div>
      </>
    );
  }
  if (requests.length === 0) {
    return (
      <>
        <div className="Circular-Progress ">
          You don't have any request currently
        </div>

        <div className="mt-3 text-center">
          <button
            onClick={() => {
              props.history.push("/create-request");
            }}
            className="custom-btn-small red-btn "
          >
            Create a request now
          </button>
        </div>
      </>
    );
  }
  return (
    <div>
      {requests.map((request, i) => (
        <RequestCard
          key={i}
          request={request}
          fetchActiveRequests={fetchActiveRequests}
        />
      ))}
    </div>
  );
}

export default withRouter(Active);
